import React, {useCallback, useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router";
import {useTranslation} from 'react-i18next';
import {AxiosError} from 'axios';
import {Location} from 'history';
import client from 'lib/CommonApi/client';
import {
  callAlertWeb,
  callNativeWeb,
  clickMoveToAppWeb,
  footerShowEventWeb,
  hideProgressWeb,
  showProgressWeb
} from 'common/appInterface';
import stringUtils from 'common/stringUtils';
import { CardProductCode, CardProductCodeName } from '../../constants/Card';
import { getVersionUrl } from 'common/cacheOverwrite';

const ProductListPage: React.FC = () => {
  /** Location State */
  const location = useLocation() as Location<LocationState>;
  /** Navigate */
  const navigate = useNavigate();
  /** 다국어처리 */
  const { t, i18n } = useTranslation();

  const screenId = "APPL01";
  const screenName = t("APPL01.title");

  const [productList, setProdcutList] = useState<Product[]>([]);
  const [debitState, setDebitState] = useState<CardDebitState | null>(null);

  /** backKeyEvent_App 처리 (APP > WEB) */
  const callbackBackkeyEvent = useCallback(() => {
    if(location.state.query.menuCode !== '9'){
      navigate(-1);
    }
  }, [navigate, location.state.query.menuCode]);

  /** 카드상품 조회 */
  const callProductList = useCallback(async () => {
    showProgressWeb();
    await client.get("/api/app/product", { params: location.state.query }).then(response => {
      if (!stringUtils.checkValueNull(response.data.response)) {
        setProdcutList(response.data.response.filter((value: Product) => value.useYn === "Y"));
      }
    }).catch((e: AxiosError) => {
      callAlertWeb("ERROR", "99", e.message);
    }).finally(() => {
      hideProgressWeb();
    });
  }, [location]);

  /** 출금동의여부조회 */
  const callDebitState = useCallback(async () => {
    await client.get('/api/app/manage/debit/state', {
      params: {
        ...location.state.query
      }
    }).then(response => {
      setDebitState(response.data.response);
    }).catch((e: AxiosError) => {
      callAlertWeb('ERROR', '99', e.message);
    });
  }, [location.state.query]);


  /** 카드신청 클릭 */
  const clickApply = useCallback(async (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    const cardProductCode = e.currentTarget.dataset["code"];

    switch (Number(cardProductCode)) {
      case CardProductCode.QuickCard:
        clickMoveToAppWeb("N876");
        break;
      default:
        navigate("/product/" + cardProductCode, { state: {...location.state, userInfo: debitState, upgrade: false} });
        break;
    }
  }, [location.state, navigate, debitState]);

  // 최초실행
  useEffect(() => {
    // 언어설정
    i18n.changeLanguage(location.state.query.languageCode);
    // callNative_Web 처리 (WEB > APP)
    callNativeWeb(screenId, screenName, location.state.from === "/intro" ? "Y" : "N");
    // 하단바 제어
    footerShowEventWeb(location.state.from === "/intro" ? "Y" : "N");

    console.log("QUERY STATE333");
    console.log(location.state);

    callProductList();
    callDebitState();

    // BODY클래스 추가
    document.body.classList.add("bgColorTy03");

    return () => {
      // BODY클래스 제거
      document.body.classList.remove("bgColorTy03");
    }

    // 최초한번실행 useEffect() Warning 제거
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    document.addEventListener("backpress", callbackBackkeyEvent);
    return () => document.removeEventListener("backpress", callbackBackkeyEvent);
  }, [callbackBackkeyEvent]);

  return (
    <div id="wrap">
      <div id="container" className="pcHidden">
        <section className="contents cardWrapSub">
          <div className="inner">
            <div className="section cardListWrap">
              <ul className="cardList">
                {productList.map((value) => (
                    <li className="card clfix cardActive" key={value.cardProductCode} onClick={clickApply} data-code={value.cardProductCode}>
                      <div className="thumb">
                        <img src={getVersionUrl(localStorage.getItem(`${value.cardProductCode}_B`) as string)} alt="" />
                        <img src={getVersionUrl(localStorage.getItem(`${value.cardProductCode}_C`) as string)} alt="" />
                        <div className="description">
                          <span className="tit">{CardProductCodeName[Number(value.cardProductCode)]}</span>
                          <ul className="name">
                            <li>{t(`APPL01.explan01.${value.cardProductCode}`)}</li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ProductListPage;